import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    type LocaleSwitcherShortTitleConstantType,
    type LocaleSwitcherBadgeColorConstantType,
    type LocaleSwitcherIconColorConstantType,
    type LocaleSwitcherDynamicStyleType,
    type LocaleSwitcherDefaultKey
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getButtonCustomColor
} from "../button/stylesheet";

export const LOCALE_SWITCHER_DEFAULT_KEYS: Array<LocaleSwitcherDefaultKey> = [
    "tr-TR",
    "en-US"
];

export const LOCALE_SWITCHER_TITLE_KEYS: Record<LocaleSwitcherDefaultKey, keyof NCoreUIKit.Translation> = {
    "tr-TR": "locale-switcher-turkish",
    "en-US": "locale-switcher-english"
};

export const LOCALE_SWITCHER_ICON_COLORS: Record<LocaleSwitcherDefaultKey, keyof NCoreUIKit.ProjectColorPalette> = {
    "tr-TR": "turkish",
    "en-US": "english"
};

export const getLocaleSwitcherShortTitle = ({
    shortTitle,
    localeKey
}: LocaleSwitcherShortTitleConstantType): string => {
    if(shortTitle) {
        return shortTitle;
    }

    const [
        language
    ] = String(localeKey).split("-");

    return (language || String(localeKey)).toUpperCase();
};

export const getLocaleSwitcherIconColor = ({
    isCustomIconColor,
    buttonIconColor,
    isDisabled,
    iconColor,
    colors
}: LocaleSwitcherIconColorConstantType): string | undefined => {
    if(isDisabled || isCustomIconColor || !iconColor) {
        return buttonIconColor;
    }

    return getButtonCustomColor({
        customColor: iconColor,
        colors
    });
};

export const getLocaleSwitcherBadgeColor = ({
    buttonIconColor,
    isDisabled,
    iconColor,
    colors
}: LocaleSwitcherBadgeColorConstantType): string | undefined => {
    if(isDisabled) {
        return buttonIconColor;
    }

    if(!iconColor) {
        return colors.content.container.neutral;
    }

    return getButtonCustomColor({
        customColor: iconColor,
        colors
    });
};

const stylesheet = StyleSheet.create({
    badge: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    badgeTitle: {
        textAlign: "center"
    }
});

export const useStyles = ({
    badgeColor,
    iconSizes,
    radiuses,
    size
}: LocaleSwitcherDynamicStyleType) => {
    const badgeSize = Math.max(size, iconSizes.large);

    const styles = {
        badge: {
            backgroundColor: badgeColor,
            borderRadius: radiuses.full,
            minHeight: badgeSize,
            minWidth: badgeSize
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
